module.exports = __webpack_public_path__ + "static/img/14areaA_3.7dd2d3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/14areaA_3.png
// module id = 895
// module chunks = 1